import React from 'react';
import PropTypes from 'prop-types';

export function NotesList(props) {
  const renderNote = (note, key) => (
    <li key={key} className='step_btm_notesBlock_noteList_item'>
      {note}
    </li>
  );

  return (
    <div className='step_btm_notesBlock'>
      <p className='step_btm_notesBlock_title'>Notes:</p>
      <ul className='step_btm_notesBlock_noteList'>
        {props.notes.map(renderNote)}
      </ul>
      <span className='step_btm_notesBlock_hide' onClick={props.close}>
        hide
      </span>
    </div>
  );
}

NotesList.propTypes = {
  /**
   * List of notes
   */
  notes: PropTypes.arrayOf(PropTypes.string),
  /**
   * Function to close NoteListView
   */
  close: PropTypes.func,
};

NotesList.defaultProps = {
  notes: [],
};
